// Default images rendered when API photo/thumbnail fields are null OR the URL fails to load.
// Encoded inline as SVG data URIs so no separate asset bundle is needed.

export const DEFAULT_AVATAR =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'>
      <rect width='100' height='100' fill='#E5E7EB'/>
      <circle cx='50' cy='40' r='18' fill='#9CA3AF'/>
      <path d='M15 92 Q50 58 85 92 Z' fill='#9CA3AF'/>
    </svg>`
  );

// Served from /public so it survives the CRA build pipeline.
// Drop the file at public/default-banner.png in this app.
export const DEFAULT_COURSE_THUMBNAIL =
  (process.env.PUBLIC_URL || "") + "/default-banner.png";

/**
 * onError handler that swaps to a fallback image and clears itself so it can't loop.
 * Usage: <img src={...} onError={imageOnError(DEFAULT_AVATAR)} />
 */
export const imageOnError = (fallback) => (e) => {
  if (e?.target) {
    e.target.onerror = null;
    e.target.src = fallback;
  }
};
